import { createSlice } from '@reduxjs/toolkit';

interface UIState {
  sidebarOpen: boolean;
  themeMode: 'light' | 'dark';
  notifications: any[];
  loading: boolean;
}

const initialState: UIState = {
  sidebarOpen: true,
  themeMode: localStorage.getItem('themeMode') === 'dark' ? 'dark' : 'light',
  notifications: [],
  loading: false
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setThemeMode: (state, action) => {
      state.themeMode = action.payload;
      localStorage.setItem('themeMode', action.payload);
    },
    addNotification: (state, action) => {
      state.notifications.push(action.payload);
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload
      );
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

export const { 
  toggleSidebar, 
  setThemeMode, 
  addNotification, 
  removeNotification,
  setLoading 
} = uiSlice.actions;

export default uiSlice.reducer;